/* PULMUR - "Is this my taste?" opens the coffee quiz in a dialog on the PDP.
   On first click it fetches the quiz page and lifts the quiz section out of it.
   ponytail: a full page fetch, not the Section Rendering API. section_id has to
   match the generated `template--<id>__<key>`, which nobody can hand-write
   reliably; one extra fetch on click is cheaper than a broken button. */
(function () {
  var cache = null;
  var dialog = null;

  function ensureDialog() {
    if (dialog) return dialog;
    dialog = document.createElement("dialog");
    dialog.className = "pbt-modal";
    dialog.innerHTML =
      '<button type="button" class="pbt-modal__close" data-modal-close aria-label="Close">&times;</button>' +
      '<div class="pbt-modal__body" data-modal-body></div>';
    document.body.appendChild(dialog);

    dialog.addEventListener("click", function (e) {
      if (e.target === dialog || e.target.hasAttribute("data-modal-close")) dialog.close();
    });
    return dialog;
  }

  function loadScript(src) {
    return new Promise(function (resolve) {
      if (window.PulmurQuiz || !src) return resolve();
      var el = document.createElement("script");
      el.src = src;
      el.onload = resolve;
      el.onerror = resolve;
      document.head.appendChild(el);
    });
  }

  function extract(html) {
    var doc = new DOMParser().parseFromString(html, "text/html");
    var quiz = doc.querySelector("[data-pbt-quiz]");
    if (!quiz) return null;
    var wrap = quiz.closest("section.pbt") || quiz;
    return wrap.outerHTML;
  }

  function start(body, js) {
    loadScript(js).then(function () {
      if (window.PulmurQuiz) window.PulmurQuiz.init(body);
    });
  }

  function open(btn) {
    var d = ensureDialog();
    var body = d.querySelector("[data-modal-body]");
    var url = btn.getAttribute("data-quiz-url") || "/pages/coffee-quiz";
    var js = btn.getAttribute("data-quiz-js");

    if (typeof d.showModal !== "function") {
      window.location.href = url; // very old browser: just send them to the page
      return;
    }
    d.showModal();

    if (cache) {
      body.innerHTML = cache;
      start(body, js);
      return;
    }

    body.innerHTML =
      '<div class="pbt-loader pbt-modal__loading"><span class="pbt-loader__ring"></span>' +
      '<p class="pbt-loader__text">Loading the quiz</p></div>';

    fetch(url, { headers: { "X-Requested-With": "fetch" } })
      .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
      .then(function (html) {
        var markup = extract(html);
        if (!markup) return Promise.reject("no quiz section");
        cache = markup;
        body.innerHTML = markup;
        start(body, js);
      })
      .catch(function () {
        body.innerHTML =
          '<div class="pbt-modal__loading" style="text-align:center;padding:60px 24px">' +
          '<p>The quiz did not load. <a href="' + url + '">Open it on its own page</a>.</p></div>';
      });
  }

  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-pbt-taste]");
    if (btn) {
      e.preventDefault();
      open(btn);
    }
  });
})();
